import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles({
  card: {
    position: "relative",
    width: "100%",
    marginTop: "1rem",
    backgroundColor: "#fff",
  },
  equipment: {
    fontSize: "1.25rem",
    maxWidth: "70%",
  },
  info: {
    fontSize: "0.875rem",
    color: "#000",
  },
  label: {
    position: "absolute",
    top: "50%",
    right: "0.625rem",
    transform: "translate(0%, -50%)",
    "& .MuiCardContent-root": {
      padding: "0.25rem",
      "& p": {
        textAlign: "center",
      },
    },
    "& p": {
      color: "#fff",
      fontSize: "0.75rem",
      fontWeight: 500,
    }
  }
});